/** VIS1 page frame (owner G1 2026-10-13). Widths live in design-tokens.css (--frame-max, --body-narrow). */
export const PAGE_WIDTH = Object.freeze({ FULL: 'full', NARROW: 'narrow' });

export const FRAME_SIZE = Object.freeze({ COMPACT: 'compact', MEDIUM: 'medium', WIDE: 'wide' });

/** Content width (px) of the shell's <main>, not the viewport: the sidebar is already subtracted. */
export const FRAME_BREAKPOINT = Object.freeze({ MEDIUM: 640, WIDE: 1024 });
